import { defineEffect } from '../../../core/effect';
import { summonBank } from '../fx/summonBank';

/**
 * **通常召喚（軽い召喚バンク）**（Issue #578 v1。指示書 `../direction/summoning.md`。キービジュアルは無い＝方向は人が決めた）。
 * 組み立ては特殊召喚（`spsummoning.js`）と共有（`../fx/summonBank.js`）。
 */
export default defineEffect(summonBank({
  situation: 'summoning',
  role: 'effect',
  label: '通常召喚（軽い召喚バンク。カードが盤から HUD を貫いて飛び出す）',
  color: '#ffc43d',
  tag: ['SUMMON'],
}), 'summoning_effect.js');
